import styled from 'styled-components/macro';
import AdvancedModal from '@tovia/man-ui/lib/components/Modal/AdvancedModal';

export const UpgradeModal = styled(AdvancedModal)`
  text-align: center;

  p:first-child,
  p:last-of-type {
    margin: 0;
  }
`;
